import { render, staticRenderFns } from "./FormNewPromotion.vue?vue&type=template&id=c6bea0e2&scoped=true&"
import script from "./FormNewPromotion.vue?vue&type=script&lang=js&"
export * from "./FormNewPromotion.vue?vue&type=script&lang=js&"
import style0 from "./FormNewPromotion.vue?vue&type=style&index=0&id=c6bea0e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bea0e2",
  null
  
)

export default component.exports